/** Shopify CDN: Minification failed

Line 40:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 41:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 41:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 42:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 42:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 47:42 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 54:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 59:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 63:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 27:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 28:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 28:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 29:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 29:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 34:42 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 41:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 46:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 50:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 14:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 15:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 15:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 16:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 16:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 21:42 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 28:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 33:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 37:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
(async () => {
    const { Core } = await importModule('Core');
    const { 
        $hide,
        $show 
    } = await importModule('Utils');

    customElements.define('page-spinner', class extends Core {

        subscriptions = {
            'spinner:show': '_onShow',
            'spinner:hide': '_onHide'
        }

        render() {
            this.subscribe('spinner:show', { global: true });
            this.subscribe('spinner:hide', { global: true });
        }
        
        _onShow() {
            $show(this);
        }

        _onHide() {
            $hide(this);
        }
    })
})();